// Cistella de la botiga: la galeta `cart` ({book_id: unitats}) i `$root.cart` (total d'unitats, per al comptador).
// Tot el que canvia la cistella hauria de passar per aquí: el total es recompta sempre de la galeta (abans cada
// component el sumava/restava a mà i es desquadrava) i s'avisa amb `$root.$emit('cart-changed')` perquè la
// cistella (CartNav) i el checkout es tornin a pintar, encara que el total no canviï (p. ex. canviar pel pack).

import Vue from 'vue'

// Puja cada cop que es desa la cistella: la galeta no és reactiva i `$root.cart` no canvia si el total d'unitats és el
// mateix (p. ex. canviar el quadern pel pack). Qui la llegeixi en un computed es torna a calcular.
export const cartVersion = Vue.observable({n: 0})

export function getCart(vm) {
  const list = vm.$cookies.get('cart')
  return list && typeof list === 'object' ? list : {}
}

export function countCart(list) {
  return Object.values(list || {}).reduce((s, q) => s + (Number(q) > 0 ? Number(q) : 0), 0)
}

export function setCart(vm, list) {
  const clean = {}
  for (const [id, q] of Object.entries(list || {})) if (Number(q) > 0) clean[id] = Number(q)
  vm.$cookies.set('cart', clean)
  vm.$root.cart = countCart(clean)
  cartVersion.n++
  vm.$root.$emit('cart-changed')
  return clean
}

export function addToCart(vm, book_id, units = 1) {
  const list = getCart(vm)
  list[book_id] = (Number(list[book_id]) || 0) + units
  return setCart(vm, list)
}

/**
 * Afegeix un pack: substitueix una unitat del quadern d'exàmens i dels apunts de l'assignatura que ja hi hagi a la
 * cistella (el pack ja els inclou i, si no, el paguen dos cops)
 */
export function addPackToCart(vm, pack, parts = [pack.examBookId, pack.notesBookId]) {
  const list = getCart(vm)
  for (const id of parts) {
    if (!id) continue
    if (list[id] > 1) list[id]--
    else delete list[id]
  }
  list[pack.book_id] = (Number(list[pack.book_id]) || 0) + 1
  return setCart(vm, list)
}

/** Treu una unitat (o el llibre sencer amb `all`) */
export function removeFromCart(vm, book_id, all = false) {
  const list = getCart(vm)
  if (all || !(list[book_id] > 1)) delete list[book_id]
  else list[book_id]--
  return setCart(vm, list)
}
